import { useMainStore } from '@/stores/mainStore';

/**
 * Service de gestion des dossards offerts pour les groupes
 * Responsable de la gestion des dossards offerts pour les groupes
 */
class BibOfferService {
    constructor() {
        // Le service est un singleton
    }

    /**
     * Gère l'offre de dossards pour un groupe
     * 
     * Cette fonction vérifie s'il y a des dossards à offrir pour un groupe. Si c'est le cas, elle supprime 
     * les codes d'offre de dossard existants, trie les inscriptions par prix, puis offre des dossards 
     * aux inscriptions les moins chères qui sont éligibles.
     * 
     * Le nombre de dossards à offrir est déterminé par le nombre total d'inscriptions éligibles divisé 
     * par le nombre de dossards offerts par groupe.
     * 
     * @param {Object} bookingStore - Le store de réservation
     * @returns {void}
     */
    handleDossardOffertGroupe(bookingStore) {
        const mainStore = useMainStore();
        const nb_bib = mainStore.module.dossard_offert_groupe;
        if (!nb_bib) return;
        this.deleteBibOfferCode(bookingStore);
        if (bookingStore.inscriptions.length < nb_bib) return;
        const sortedInscriptionByPrice = bookingStore.inscriptions.slice().sort((a, b) => a.get_prix_course() - b.get_prix_course());
        const sortedInscriptionByPriceWithPrice = sortedInscriptionByPrice.filter(inscription => inscription.get_prix_course() > 0 && !inscription.code_reduction);
        const nbTotalInscriptions = bookingStore.inscriptions.filter(inscription => inscription.get_prix_course() > 0).length;
        const nbInscriptionsToOffer = Math.floor(nbTotalInscriptions / nb_bib);
        for (let i = 0; i < nbInscriptionsToOffer; i++) {
            const cheapestInscription = sortedInscriptionByPriceWithPrice[i];
            const index = bookingStore.inscriptions.findIndex(inscription => inscription == cheapestInscription);
            if (index !== -1) {
                bookingStore.inscriptions[index].offer_bib();
            }
        }
    }

    /**
     * Supprime le code de réduction "DOSSARD OFFERT" de toutes les inscriptions
     * 
     * @param {Object} bookingStore - Le store de réservation
     * @returns {void}
     */
    deleteBibOfferCode(bookingStore) {
        for (let i = 0; i < bookingStore.inscriptions.length; i++) {
            if (bookingStore.inscriptions[i].code_reduction && bookingStore.inscriptions[i].code_reduction.nom == "DOSSARD OFFERT") {
                bookingStore.inscriptions[i].code_reduction = null;
                bookingStore.inscriptions[i].update_cart("code_reduction");
                bookingStore.inscriptions[i].compute_cart();
            }
        }
    }
}

export default new BibOfferService();

